<template>
    <div class="container">
        <div class="row">
            <h1 class="page-title page-title--single">
                <span>Invoices</span> Referral partner
            </h1>
        </div>

        <div class="row referral-invoices-filter filter">
            <form method="get">
                <div class="group-filter group-filter--left">
                    <div class="form-field form-field__select">
                        <label for="agency">Referral partner</label>
                        <select
                            name="agency"
                            id="agency"
                            @change="setValue"
                            class="js-select-custom"
                        >
                            <option value="">All</option>
                            <option
                                v-for="partner in partners"
                                :key="partner.id"
                                :value="partner.id"
                                v-text="partner.name"
                            />
                        </select>
                    </div>
                    <div class="select">
                        <div
                            class="form-field form-field__select form-field--inline-flex"
                        >
                            <label for="period">Sale Period</label>
                            <select
                                name="period"
                                id="period"
                                @change="setValue"
                                class="js-select-custom"
                            >
                                <option value="">All</option>
                                <option
                                    v-for="period in periods"
                                    :key="period"
                                    :value="period"
                                    v-text="formatDatePeriod(period)"
                                />
                            </select>
                        </div>
                    </div>
                </div>

                <div class="group-filter group-filter--status">
                    <div class="checkbox">
                        <div
                            class="form-field checkbox-wrap"
                            v-for="filter in statuses"
                            :key="filter.id"
                        >
                            <input
                                type="checkbox"
                                :id="`filter_status_${filter.id}`"
                                :value="filter.id"
                                @change="checkboxValue"
                                name="status[]"
                            />
                            <label :for="`filter_status_${filter.id}`"
                                ><i class="icon icon-checkmark"></i
                            ></label>
                            {{ filter.name }}
                        </div>
                    </div>
                </div>
            </form>
        </div>

        <div
            class="row master-invoices-pagination master-invoices-pagination--top"
        ></div>

        <div class="row master-invoices-table">
            <div class="table-wrap">
                <table class="table">
                    <thead>
                        <tr>
                            <th>Invoice number</th>
                            <th>Partner</th>
                            <th>Sale period</th>
                            <th>Status</th>
                            <th>Payable amount</th>
                            <th>Paid</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="loading">
                            <td colspan="6">
                                <clip-loader
                                    :loading="loading"
                                    :color="'#ec4657'"
                                    :size="'45px'"
                                ></clip-loader>
                            </td>
                        </tr>
                        <tr v-else-if="!items.length && !loading">
                            <td colspan="6"><center>No data</center></td>
                        </tr>
                        <tr v-else v-for="item in items" :key="item.id">
                            <td>2345/0312</td>
                            <td>
                                <a href="#">Best partner</a>
                            </td>
                            <td>September/22</td>
                            <td>Completed</td>
                            <td>$ 1,500</td>
                            <td>12/29/22</td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="row master-invoices-pagination jus-c--right"></div>
    </div>
</template>

<script>
import ClipLoader from "vue-spinner/src/ClipLoader.vue";
import axios from "axios";

export default {
    name: "Referral_Partners",
    props: ["agencies", "statuses", "periods"],
    components: {
        ClipLoader,
    },
    data() {
        return {
            selectedStatus: [],
            agency: null,
            period: null,
            loading: false,
            items: [],
        };
    },

    mounted() {},

    methods: {
        setValue(e) {
            const name = e.target.name;
            const value = e.target.value;

            this[name] = value;

            this.fetchData();
        },
        checkboxValue(e) {
            if (e.target.checked) {
                this.selectedStatus.push(e.target.value);
            } else {
                this.selectedStatus = this.selectedStatus.filter(
                    (i) => i != e.target.value
                );
            }

            this.fetchData();
        },
        formatDatePeriod(date) {
            const options = { year: "numeric", month: "long" };
            const _date = new Date(date);

            return _date.toLocaleDateString("en-GB", options);
        },
        fetchData() {
            this.loading = true;

            axios
                .post("/", {
                    status: this.selectedStatus,
                    period: this.period,
                    agency: this.agency,
                })
                .then((res) => {
                    this.loading = false;
                    if (res.data.length) {
                        this.items = res.data;
                    } else {
                        this.items = [];
                    }
                })
                .catch((err) => {
                    this.loading = false;
                });
        },
    },
};
</script>
